/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompanyProposalSettingsResourceValidation } from './';
import {
    ClientCompanyProposalSettingsResourceValidationFromJSON,
    ClientCompanyProposalSettingsResourceValidationFromJSONTyped,
    ClientCompanyProposalSettingsResourceValidationToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyProposalSettingsResource
 */
export interface ClientCompanyProposalSettingsResource {
    /**
     * 
     * @type {ClientCompanyProposalSettingsResourceValidation}
     * @memberof ClientCompanyProposalSettingsResource
     */
    validation: ClientCompanyProposalSettingsResourceValidation;
}

/**
 * Check if a given object implements the ClientCompanyProposalSettingsResource interface.
 */
export function instanceOfClientCompanyProposalSettingsResource(value: object): value is ClientCompanyProposalSettingsResource {
    if (!('validation' in value) || value['validation'] === undefined) return false;
    return true;
}

export function ClientCompanyProposalSettingsResourceFromJSON(json: any): ClientCompanyProposalSettingsResource {
    return ClientCompanyProposalSettingsResourceFromJSONTyped(json, false);
}

export function ClientCompanyProposalSettingsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyProposalSettingsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'validation': ClientCompanyProposalSettingsResourceValidationFromJSON(json['validation']),
    };
}

export function ClientCompanyProposalSettingsResourceToJSON(value?: ClientCompanyProposalSettingsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'validation': ClientCompanyProposalSettingsResourceValidationToJSON(value['validation']),
    };
}

